export default __webpack_public_path__ + "static/media/dtftransfers-logo.340bb88f.png";